<form class="form" [formGroup]="preferenceForm" (submit)="save()">
  <h3>Search preferences</h3>
  <p>Configure the sources and matching rules CareAI should use for this conversation.</p>

  <div class="form__field">
    <label class="input__label" for="sourceTypes">Sources</label>
    <p-multiselect
      id="sourceTypes"
      [options]="sources"
      optionLabel="name"
      optionValue="enumId"
      formControlName="sourceTypes"
      placeholder="Select sources">
    </p-multiselect>
    <small class="input__hint">Choose which knowledge sources CareAI can search.</small>
  </div>

  <div class="form__row form__row--half">
    <div class="form__field preferences-section">
      <label class="input__label" for="term">Included terms</label>
      <small class="input__hint"> Add terms that should be present in matching results. </small>
      <div class="term-filter" formGroupName="includedTermsFilter">
        <div class="term-filter__chips">
          @for (term of includedFilterTerms; track term) {
            <p-chip [removable]="true" (onRemove)="removeTerm(term, 'included')">{{ term }}</p-chip>
          }
        </div>
        <div class="term-filter__new-term" [formGroup]="newIncludeTermForm">
          <input pInputText id="term" formControlName="term" placeholder="Add a term..."/>
          <p-button
            label="Add"
            severity="secondary"
            type="button"
            (onClick)="addTerm(newIncludeTermForm, 'included')" />
        </div>
        <div class="form__field">
          <label class="input__label" for="includedTermRequirement">Requirement</label>
          <p-select
            id="includedTermRequirement"
            [options]="allTermRequirements"
            optionLabel="name"
            optionValue="enumId"
            formControlName="termRequirement"
            placeholder="Select requirement">
          </p-select>
        </div>
        <div class="form__field">
          <label class="input__label" for="includedTargetFields">Targets</label>
          <p-multiselect
            id="includedTargetFields"
            [options]="allTermTargets"
            optionLabel="name"
            optionValue="enumId"
            formControlName="targetFields"
            placeholder="Select targets">
          </p-multiselect>
        </div>
      </div>
    </div>

    <div class="form__field preferences-section">
      <label class="input__label" for="term">Excluded terms</label>
      <small class="input__hint"> Add terms that should filter results out. </small>
      <div class="term-filter" formGroupName="excludedTermsFilter">
        <div class="term-filter__chips">
          @for (term of excludedFilterTerms; track term) {
            <p-chip [removable]="true" (onRemove)="removeTerm(term, 'excluded')">{{ term }}</p-chip>
          }
        </div>
        <div class="term-filter__new-term" [formGroup]="newExcludeTermForm">
          <input pInputText id="term" placeholder="Add a term..." formControlName="term" />
          <p-button
            label="Add"
            severity="secondary"
            type="button"
            (onClick)="addTerm(newExcludeTermForm, 'excluded')" />
        </div>
        <div class="form__field">
          <label class="input__label" for="excludedTermRequirement">Requirement</label>
          <p-select
            id="excludedTermRequirement"
            [options]="allTermRequirements"
            optionLabel="name"
            optionValue="enumId"
            formControlName="termRequirement"
            placeholder="Select requirement">
          </p-select>
        </div>
        <div class="form__field">
          <label class="input__label" for="excludedTargetFields">Targets</label>
          <p-multiselect
            id="excludedTargetFields"
            [options]="allTermTargets"
            optionLabel="name"
            optionValue="enumId"
            formControlName="targetFields"
            placeholder="Select targets">
          </p-multiselect>
        </div>
      </div>
    </div>
  </div>

  <div class="form__field">
    <label class="input__label" for="fromLastModified">From Date</label>
    <p-datepicker
      id="fromLastModified"
      tooltipPosition="top"
      dateFormat="dd/mm/yy"
      formControlName="fromLastModified"
      placeholder="dd/MM/yyyy" />
  </div>
  <div class="form__field">
    <label class="input__label" for="searchDepth">Search Depth</label>
    <p-select
      id="searchDepth"
      [options]="allSearchDepths"
      optionLabel="name"
      optionValue="enumId"
      formControlName="searchDepth"
      placeholder="Select depth"></p-select>
    <small class="input__hint">Choose how exhaustive the search should be.</small>
  </div>

  <div class="form__field form__field--horizontal">
    <p-toggleswitch id="collapseMatches" formControlName="collapseMatches" />
    <label class="input__label" for="collapseMatches">Group similar results together to reduce noise</label>
  </div>

  <div class="page__actions">
    <p-button
      class="page__action"
      label="Cancel"
      severity="secondary"
      (click)="cancelPreferences.emit()" />
    <p-button class="page__action" label="Save" type="submit" [disabled]="!preferenceForm.valid" />
  </div>
</form>
